/* assets/kon-minqty-cart.js
 * Dawn CART: enforce minimum qty for items tagged (via Liquid) with:
 *   data-kon-minqty="1" data-kon-minqty-min="X"
 *
 * Behavior:
 * - If user tries qty > 0 and < min => force back to min immediately + show alert under <quantity-input>
 * - Works with Dawn AJAX cart updates (no reload) without infinite loops
 *
 * IMPORTANT:
 * - Include this script ONCE (layout/theme.liquid), not inside cart section.
 *   {% if template.name == 'cart' %}<script src="{{ 'kon-minqty-cart.js' | asset_url }}" defer></script>{% endif %}
 */

(function () {
  // -----------------------------
  // HARD GUARD: run only once
  // -----------------------------
  if (window.__KON_MINQTY_CART_LOADED__) return;
  window.__KON_MINQTY_CART_LOADED__ = true;

  // -----------------------------
  // Utils
  // -----------------------------
  function safeInt(v, fb) {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : fb;
  }

  function isCartPage() {
    return location.pathname === "/cart" || location.pathname.indexOf("/cart") === 0;
  }

  function getRowFromEl(el) {
    return el && el.closest ? el.closest("tr.cart-item[data-kon-minqty='1']") : null;
  }

  function getMin(row) {
    // NO fallback: must come from Liquid row attribute (customizer-driven)
    const m = safeInt(row.getAttribute("data-kon-minqty-min"), null);
    return m && m > 0 ? m : null;
  }

  function getQtyInput(row) {
    return row ? row.querySelector("input.quantity__input[name='updates[]']") : null;
  }

  function readQty(input) {
    return safeInt(input.value, 0);
  }

  function applyMinToInput(input, minVal) {
    input.setAttribute("min", String(minVal));
    input.setAttribute("data-min", String(minVal));
  }

  // -----------------------------
  // Alert placement: MUST stay inside table cell
  // - Insert after <quantity-input> but inside <td class="cart-item__quantity">
  // -----------------------------
  function ensureAlertUnderQuantityInput(row) {
    const qtyTd = row.querySelector("td.cart-item__quantity");
    if (!qtyTd) return null;

    const widget = qtyTd.querySelector("quantity-input.quantity.cart-quantity");
    if (!widget) return null;

    // Prefer an alert that is a direct child of the TD (stable & easy to find)
    let el = qtyTd.querySelector(":scope > [data-kon-minqty-row-alert]");
    if (el) return el;

    el = document.createElement("div");
    el.setAttribute("data-kon-minqty-row-alert", "1");
    el.style.cssText =
      "margin-top:8px;padding:10px 12px;border:1px solid #d22;border-radius:10px;" +
      "background:#fff5f5;color:#8a0000;font-size:13px;line-height:1.35;display:none;";

    // Valid table DOM: insert inside TD, directly after the quantity-input widget
    widget.insertAdjacentElement("afterend", el);

    return el;
  }

  function showRowAlert(row, msg) {
    const el = ensureAlertUnderQuantityInput(row);
    if (!el) return;
    el.textContent = msg;
    el.style.display = "block";
  }

  function hideRowAlert(row) {
    const qtyTd = row.querySelector("td.cart-item__quantity");
    if (!qtyTd) return;
    const el =
      qtyTd.querySelector(":scope > [data-kon-minqty-row-alert]") ||
      qtyTd.querySelector("[data-kon-minqty-row-alert]");
    if (el) el.style.display = "none";
  }

  // -----------------------------
  // Core enforcement
  // -----------------------------
  function enforceRow(row, attemptedQtyForMessage) {
    const minVal = getMin(row);
    const input = getQtyInput(row);
    if (!minVal || !input) return true;

    applyMinToInput(input, minVal);

    const qty = readQty(input);

    // Allow remove
    if (qty === 0) {
      hideRowAlert(row);
      return true;
    }

    if (qty < minVal) {
      // Prevent re-entry loops from our own programmatic change
      if (input.__konSetting) return false;
      input.__konSetting = true;

      const attempted =
        Number.isFinite(attemptedQtyForMessage) ? attemptedQtyForMessage : qty;

      // Force to min
      input.value = String(minVal);

      // Show inline alert under <quantity-input>
      showRowAlert(
        row,
        `Cantidad mínima requerida: ${minVal}. Intentaste ${attempted}. Se ajustó a ${minVal}.`
      );

      // Trigger Dawn cart update (AJAX)
      input.dispatchEvent(new Event("change", { bubbles: true }));

      setTimeout(() => {
        input.__konSetting = false;
      }, 80);

      return false;
    }

    hideRowAlert(row);
    return true;
  }

  function enforceAllVisible() {
    const rows = Array.from(
      document.querySelectorAll("tr.cart-item[data-kon-minqty='1']")
    );
    rows.forEach((row) => {
      enforceRow(row);
    });
  }

  // -----------------------------
  // Debounce to avoid loops during section re-render
  // -----------------------------
  let debounceTimer = null;
  function scheduleEnforce() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      enforceAllVisible();
    }, 80);
  }

  // -----------------------------
  // Event handlers
  // -----------------------------
  function onMinusClick(e) {
    const btn =
      e.target && e.target.closest
        ? e.target.closest("button.quantity__button[name='minus']")
        : null;
    if (!btn) return;

    const row = getRowFromEl(btn);
    if (!row) return;

    const input = getQtyInput(row);
    const minVal = getMin(row);
    if (!input || !minVal) return;

    const current = readQty(input);
    const next = current - 1;

    // If decrement would go below min (and not removing), block immediately
    if (current > 0 && next > 0 && next < minVal) {
      e.preventDefault();
      e.stopPropagation();

      // Keep at min and show message
      applyMinToInput(input, minVal);

      if (current <= minVal) {
        showRowAlert(row, `Cantidad mínima requerida: ${minVal}. No puedes bajar de ${minVal}.`);
      } else {
        // If somehow above min, enforceRow will correct if needed
        enforceRow(row, next);
      }

      return;
    }
  }

  function onQtyInput(e) {
    const t = e.target;
    if (!(t && t.matches && t.matches("input.quantity__input[name='updates[]']"))) return;

    const row = getRowFromEl(t);
    if (!row) return;

    // Avoid forcing on every keystroke, but keep things consistent
    scheduleEnforce();
  }

  function onQtyChange(e) {
    const t = e.target;
    if (!(t && t.matches && t.matches("input.quantity__input[name='updates[]']"))) return;

    const row = getRowFromEl(t);
    if (!row) return;

    // Enforce immediately on change (Dawn updates cart here)
    enforceRow(row, readQty(t));
    scheduleEnforce();
  }

  function onQtyBlur(e) {
    const t = e.target;
    if (!(t && t.matches && t.matches("input.quantity__input[name='updates[]']"))) return;

    const row = getRowFromEl(t);
    if (!row) return;

    // Enforce on blur too (paste / manual edits)
    enforceRow(row, readQty(t));
    scheduleEnforce();
  }

  // -----------------------------
  // MutationObserver: handle Dawn AJAX re-renders without reload
  // -----------------------------
  function mountObserver() {
    const root =
      document.getElementById("main-cart-items") ||
      document.querySelector("cart-items");
    if (!root) return;

    // Do not mount multiple observers
    if (root.__konMinQtyObserverMounted) return;
    root.__konMinQtyObserverMounted = true;

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type !== "childList") continue;

        // Only react to real re-renders (ignore our own alert insertion)
        const addedEls = Array.from(m.addedNodes || []).filter(
          (n) => n && n.nodeType === 1
        );
        if (!addedEls.length) continue;

        const hasRealAdded = addedEls.some((el) => {
          return !el.hasAttribute("data-kon-minqty-row-alert");
        });

        if (hasRealAdded) {
          scheduleEnforce();
          break;
        }
      }
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  function bind() {
    // Capture minus click early to prevent UI from going below min
    document.addEventListener("click", onMinusClick, true);

    // Inputs
    document.addEventListener("input", onQtyInput, true);
    document.addEventListener("change", onQtyChange, true);
    document.addEventListener("blur", onQtyBlur, true);

    mountObserver();
  }

  // -----------------------------
  // Init
  // -----------------------------
  document.addEventListener("DOMContentLoaded", function () {
    if (!isCartPage()) return;
    bind();
    enforceAllVisible();
  });
})();
